import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { get, includes } from "lodash";
import moment from "moment";
import React, { useEffect } from "react";
import BSInput from "../../../common/js/components/BSInput";
import "./CommissionDistribution.css";

const CommissionDistribution = (props) => {
    const {
        errors,
        formDisabled,
        handleBlurValidate,
        handleInput,
        handleVoucherChange,
        setInitialPaymentMethod,
        userProfile,
        voucher,
    } = props;

    // When a new voucher is created, automatically set the submitted date to be the current date
    // By default, set payment method to Check if unspecified.
    // todo: create an enum list on the backend and automatically persist "CHECK" as the default value in the database
    // if the UI is using radio buttons for these fields, a null value should not be encountered.
    useEffect(() => {
        if (!isConsultingDeal) {
            if (get(voucher, "submittedDate", null) == null && get(voucher, "voucherStatus", null) === "Draft") {
                handleVoucherChange({ target: { id: "submittedDate", value: moment().format("YYYY-MM-DD") } });
            }
        }
        if (get(voucher, "paymentMethod", null) === null) {
            setInitialPaymentMethod("CHECK");
        }
    }, []);

    const role = get(userProfile, "role");
    const isConsultingDeal = get(voucher, "deal.transactionType") === "Consulting";
    const showPaymentMethodRequired = !voucher.paymentMethod || errors.paymentMethod;

    return (
        <React.Fragment>
            {/* Commission Distribution */}
            {!isConsultingDeal && <hr />}
            <div className="formTitleNoSpace"> Commission Distribution </div>
            {isConsultingDeal && <hr />}
            <div className="commissionDistributionFlexContainer">
                <div className="flexGrowSingle">
                    <BSInput
                        id="submittedDate"
                        label="Date*"
                        type={"date"}
                        helperText="Required"
                        errorText="Required"
                        value={voucher.submittedDate}
                        error={errors.submittedDate}
                        onChange={handleVoucherChange}
                        placeholder="Enter date"
                        disabled={formDisabled}
                        onBlurValidate={(id, value) => handleBlurValidate(null, id, value)}
                    />
                </div>
                {includes(["dataAdmin", "accounting", "dataEntry"], role) && (
                    <>
                        <div className="flexGrowSingle">
                            <BSInput
                                id="paymentAttachedDate"
                                label="Submitted With Payment Date"
                                value={
                                    voucher.paymentAttachedDate
                                        ? moment(voucher.paymentAttachedDate).format("MM/DD/YYYY h:mm A")
                                        : null
                                }
                                disabled={true}
                            />
                        </div>
                        <div className="flexGrowSingle">
                            <BSInput
                                id="printedDate"
                                label="Printed Date"
                                value={
                                    voucher?.printedDate
                                        ? moment(voucher.printedDate).format("MM/DD/YYYY h:mm A")
                                        : null
                                }
                                disabled={true}
                            />
                        </div>
                        <div className="flexGrowSingle">
                            <BSInput
                                id="acceptedDate"
                                label="Processed Date"
                                value={
                                    voucher.acceptedDate
                                        ? moment(voucher.acceptedDate).format("MM/DD/YYYY h:mm a")
                                        : null
                                }
                                disabled={true}
                            />
                        </div>
                    </>
                )}
            </div>
            <div className="commissionDistributionFlexContainerUnresponsive">
                <div className="flexGrowSingle">
                    <BSInput
                        id="totalConsiderationAmount"
                        label="Total Consideration"
                        value={get(voucher, "deal.totalConsiderationAmount")}
                        error={errors.totalConsiderationAmount}
                        onChange={(e) => handleInput("deal.totalConsiderationAmount", e.target.value)}
                        startAdornment="$"
                        placeholder="Enter amount"
                        numeric={true}
                        disabled={isConsultingDeal ? false : !(role === "accounting")}
                    />
                </div>
                <div className="flexGrowSingle">
                    <BSInput
                        id="totalCommission"
                        label="Total Commission For Transaction"
                        value={get(voucher, "deal.totalCommission")}
                        error={errors.totalCommission}
                        startAdornment="$"
                        disabled
                        numeric={true}
                    />
                </div>
            </div>
            <div className="commissionDistributionFlexContainer">
                {includes(["dataAdmin", "accounting", "dataEntry"], role) && (
                    <div className="commissionDistributionFlexContainerUnresponsive flexGrowSingle">
                        <div className="flexGrowSingle">
                            <BSInput
                                id="approvedDate"
                                label="Batch Date"
                                value={voucher.approvedDate}
                                disabled={true}
                            />
                        </div>
                        <div className="flexGrowSingle">
                            <BSInput
                                id="filedDate"
                                label="Filed (Batch Override) Date"
                                type={"date"}
                                value={voucher.filedDate}
                                onChange={handleVoucherChange}
                                disabled={false}
                            />
                        </div>
                    </div>
                )}
                <div className="commissionDistributionFlexContainer flexGrowSingle">
                    <div
                        style={{
                            marginBottom: "20px",
                            padding: errors.paymentMethod && "5px",
                            border: errors.paymentMethod && "1px red solid",
                        }}
                    >
                        <FormControl rowcomponent="fieldset">
                            <RadioGroup
                                row
                                aria-label="paymentMethod"
                                name="paymentMethod"
                                value={voucher.paymentMethod}
                                disabled={formDisabled}
                                onChange={handleVoucherChange}
                                onBlur={(e) => handleBlurValidate(null, "paymentMethod", e.target.value)}
                            >
                                <FormLabel
                                    component="legend"
                                    error={errors.paymentMethod}
                                    style={{ marginBottom: "5px" }}
                                >
                                    Payment Method
                                </FormLabel>
                                <FormControlLabel
                                    value="ACH"
                                    control={
                                        <Radio
                                            id="paymentMethod"
                                            color="primary"
                                            checked={voucher.paymentMethod === "ACH"}
                                            disabled={isConsultingDeal ? false : formDisabled}
                                        />
                                    }
                                    style={{ marginRight: "83px" }}
                                    label="ACH"
                                />
                                <FormControlLabel
                                    value="CHECK"
                                    control={
                                        <Radio
                                            id="paymentMethod"
                                            color="primary"
                                            checked={voucher.paymentMethod === "CHECK"}
                                            disabled={isConsultingDeal ? false : formDisabled}
                                        />
                                    }
                                    label="Check"
                                />
                            </RadioGroup>
                        </FormControl>
                        {showPaymentMethodRequired && (
                            <div
                                style={{
                                    color: "#E53935",
                                    fontSize: "12px",
                                    marginBottom: "10px",
                                    fontStyle: "italic",
                                }}
                            >
                                Required
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CommissionDistribution;
